export default __webpack_public_path__ + "static/media/cz.f7d5fa02.svg";